import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { BarChartTooltip } from './ChartTooltips';

interface OccupancyDay {
  label: string;
  Booked: number;
  Available: number;
}

interface Props {
  data: OccupancyDay[];
  isLoading: boolean;
}

// pos-primary green for booked bars
const BOOKED_COLOR = '#15803d';

export const OccupancyChart: React.FC<Props> = ({ data, isLoading }) => (
  <div className="rounded-2xl border border-gray-200 bg-white p-5">
    <div className="mb-4 flex items-center justify-between">
      <h4 className="text-sm font-semibold text-gray-900">Occupancy</h4>
      <div className="flex items-center gap-3 text-[10px] text-gray-400">
        <span className="flex items-center gap-1">
          <span className="inline-block h-2 w-2 rounded-sm bg-pos-primary/70" />
          Booked
        </span>
        <span className="flex items-center gap-1">
          <span className="inline-block h-2 w-2 rounded-sm bg-blue-500" />
          Available
        </span>
      </div>
    </div>

    {data.length === 0 ? (
      <div className="flex h-40 items-center justify-center text-xs text-gray-400">
        {isLoading ? 'Loading…' : 'No data for this period'}
      </div>
    ) : (
      <ResponsiveContainer width="100%" height={200}>
        <BarChart
          data={data}
          margin={{ top: 0, right: 0, left: -20, bottom: 0 }}
          barCategoryGap="20%"
        >
          <CartesianGrid
            strokeDasharray="3 3"
            vertical={false}
            stroke="#f0f0f0"
          />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 10, fill: '#9ca3af' }}
            tickLine={false}
            axisLine={false}
            interval={data.length > 20 ? 4 : 0}
          />
          <YAxis
            tick={{ fontSize: 10, fill: '#9ca3af' }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip content={<BarChartTooltip />} />
          <Bar dataKey="Booked" stackId="a" radius={[0, 0, 0, 0]}>
            {data.map((entry) => (
              <Cell key={entry.label} fill={BOOKED_COLOR} fillOpacity={0.85} />
            ))}
          </Bar>
          <Bar
            dataKey="Available"
            stackId="a"
            fill="#3B82F6"
            radius={[3, 3, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    )}
  </div>
);
